import * as React from "react";
import { DatePicker } from "components/common";
import { toUTCFromTz, toDateObject } from "util/DateTime";
import useUserDateTime from "hooks/useUserDateTime";
const AbsoluteDatePicker = ({ dateTime, onChange = () => {
}, startDate = void 0 }) => {
  const { userTimezone, formatTime } = useUserDateTime();
  const initialDateTime = toUTCFromTz(dateTime, userTimezone);
  const initialDate = formatTime(initialDateTime, "date");
  const _onDatePicked = (selectedDate) => {
    const selectedDateObject = toDateObject(selectedDate, void 0, userTimezone);
    if (!!startDate && selectedDateObject.isBefore(toDateObject(startDate, void 0, userTimezone), "day")) {
      return false;
    }
    const validInitialDateTime = initialDateTime.isValid() ? initialDateTime : toUTCFromTz(void 0, userTimezone);
    const newDate = validInitialDateTime.set({
      year: selectedDateObject.year(),
      month: selectedDateObject.month(),
      date: selectedDateObject.date()
    });
    return onChange(formatTime(newDate, "default"));
  };
  return /* @__PURE__ */ React.createElement(DatePicker, { date: initialDate, onChange: _onDatePicked, fromDate: startDate, timeZone: userTimezone });
};
export default AbsoluteDatePicker;
